const APP = require('APP')
const AttachAutoScrollToError = require('Admin/VltManagement/Helpers/scrollToFirstError')

const pathRouting = !APP.USE_FOS_ROUTING

if (pathRouting && APP.paths) {
  const p = APP.paths
  module.exports = {
    path(routeName) {
      if (p[routeName]) {
        return p[routeName]
      }
    },
  }
} else {
  const Routing = require('fosRouter')

  const _ = require('underscore')
  const Backbone = require('backbone')

  const baseUrl = Routing.getBaseUrl() || location.host
  let pushStateId = 0
  const onPageChangeFunctions = []
  let currentUrl = location.href
  let localHistory = []
  let nextHistoryPos = 1

  let routersToSearch
  let currentRouter

  /**
   * list of maps to route
   * @type {Array}
   */
  const maps = []

  const RouterModel = Backbone.Model.extend({
    basePath: APP.basePath,
    lang: APP.lang,

    initialize() {
      // setting base path to Routing class (to work with app.php etc.)
      if (window.Routing || APP.basePath) {
        Routing.setBaseUrl(this.basePath)
        delete APP.basePath
      }
    },

    /**
     * Start listening on page url change
     * @return this
     */
    historyStart() {
      const changeFn = this.pageChanged.bind(this)

      currentRouter = this.getRouterFromUrl()
      localHistory.push(currentRouter)
      this.route(currentRouter)

      window.history.replaceState({ page: pushStateId }, 'StartPage')

      window.addEventListener('popstate', changeFn)
      window.addEventListener('hashchange', changeFn)

      return this
    },

    /**
     * Method fired when page change event fired
     * @return this
     */
    pageChanged(e) {
      const pageId = e && e.state && e.state.page

      const newUrl = location.href

      if (currentUrl !== newUrl) {
        currentUrl = newUrl
        currentRouter = this.getRouterFromUrl()

        if (pageId === nextHistoryPos) {
          if (localHistory.length > pageId) {
            localHistory = localHistory.splice(0, pageId)
          }
          localHistory[nextHistoryPos] = currentRouter
          nextHistoryPos++
        } else {
          pushStateId = pageId
          nextHistoryPos = pageId + 1
        }

        this.trigger('change', currentRouter)
        this.route(currentRouter)
      }
    },

    /**
     * call routeOnMap on routeMaps
     * @return this
     */
    route() {
      _.forEach(maps, this.routeOnMap)
      return this
    },

    /**
     * call appropriete function from routeMap
     * @param  {object} map map or router_name => function
     * @return this
     */
    routeOnMap(map) {
      if (currentRouter) {
        _.forEach(map, (fn, key) => {
          if (key === currentRouter.name && _.isFunction(fn)) {
            fn(currentRouter)
          }
        })

        if (currentRouter.name.startsWith('multilotto.vlt_management.')) {
          AttachAutoScrollToError()
        }
      }
      return this
    },

    /**
     * Defining
     * @param  {object} routersMap Map routers and functions called when route match url
     * @return this
     */
    addMap(map) {
      maps.push(map)

      this.routeOnMap(map)

      return this
    },

    initPath() {
      if (!this.pathInnited) {
        this.pathInnited = true

        // SETTING DEFAULT LOCALE
        _.forEach(Routing.routes_, (route, routeName) => {
          if (route.defaults._locale) {
            if (route.defaults._locale !== APP.mainLocale) {
              route.defaults._locale = APP.mainLocale
            }
          }
        })
      }
    },

    /**
     * Get url from router name and optional params
     * @param  {string} name        router name
     * @param  {object} [params]    object of route patams
     * @return {string}             url string
     */
    path(name, params) {
      this.initPath()

      let url
      let targetPath

      if (name === 'home') {
        name = 'multilotto_site_homepage'
      }

      if (name === 'login') {
        name = 'fos_user_security_login'
        targetPath = params && params.indexOf('http') === -1 ? params.replace(this.basePath, '') : params
        if (targetPath) {
          params = { target_path: targetPath }
        }
      }

      /** add _locale only in not "admin" pages */
      if (name.indexOf('admin_multilotto') === -1) {
        params = _.defaults(params || {}, { _locale: this.lang })
      }

      _.forEach(params, (p, i) => {
        if (p === true) {
          params[i] = 1
        }
      })

      if (params && params._keys) {
        delete params._keys
      }

      url = Routing.generate(name, params)

      if (!this.getRoute(name).match(baseUrl + url)) {
        // if generated url dont match route - probably params not match regexp
        throw new Error(`params not match for route ${name}`)
      }

      return url
    },

    /**
     * Getting router object from router name string
     * @param  {string} name router name
     * @return {router}      router object
     */
    getRoute(name) {
      const route = Routing.getRoute(name)
      let inited
      let matchReqExp
      /**
       * parameters {array of arrays} with params inside:
       *     param {array}        param[0] [type=text|variable]
       *                          param[1] [url part string]
       *       if type==variable  param[2] [regexp to match varialbe]
       *       if type==variable  param[3] [variable name]
       */
      const parameters = _.cloneDeep(route.tokens).reverse()
      let regExpString = '^'
      const variables = []

      /**
       * Create regExp to match urls
       * @return {[type]} [description]
       */
      const initRoute = function () {
        _.forEach(parameters, (param, i) => {
          if (param[0] === 'variable') {
            let defaultVal
            let regExp = `(\\/${param[2]
              .replace('++', '+')
              .replace('[^/]', '[^\\/]')
              .replace(/({[0-9,]+\})\+/, '$1')})`

            if (route.defaults[param[3]] !== undefined) {
              // this variable has default value
              regExp += '?'
              defaultVal = route.defaults[param[3]]
            }
            regExpString += regExp

            variables.push({
              regExp: new RegExp(regExp),
              name: param[3],
              defaultVal,
            })
          } else {
            regExpString += param[1].replace('/', '\\/')
          }
        })
        // url finishes with "/" or "?foo=bar..."
        regExpString += '((\\?.*)|\\/)?$'
        matchReqExp = new RegExp(regExpString)

        inited = true
      }

      const getParameters = function (url) {
        // console.log(url, name, regExpString);
        const paramsArray = matchReqExp.exec(url).splice(1)
        const params = {}
        _.forEach(paramsArray, (p, i) => {
          if (variables[i]) {
            if (p && variables[i].regExp.test(p)) {
              params[variables[i].name] = p.replace('/', '')
            } else if (variables[i].defaultVal !== undefined) {
              params[variables[i].name] = variables[i].defaultVal
            }
          }
        })
        return params
      }

      route.getVariables = function () {
        if (!inited) {
          initRoute()
        }

        return variables
      }

      route.match = function (url) {
        url = url.replace(this.basePath, '')

        if (!window.history.paramsushState && url.indexOf('#') !== -1) {
          url = url.split(`#${baseUrl}`)[1]
        } else {
          url = url.split(baseUrl)[1]
        }

        if (!inited) {
          initRoute()
        }

        // console.log(url, name, regExpString);
        if (matchReqExp.test(url)) {
          // console.log(name + ' matched');
          const routerObj = {
            name,
            params: getParameters(url),
          }
          return routerObj
        }

        return false
      }.bind(this)

      return route
    },

    /**
     * initRouterToSearch from jsRoutingBundle to simple js object
     * @return this
     */
    initRoutersToSearch() {
      this.routersToSearch = {}
      const routes = Routing.getRoutes()

      _.forEach(Object.keys(routes), (val) => {
        this.routersToSearch[val] = this.getRoute(val)
      })

      return this
    },

    /**
     * Getting router object from url
     * @param  {string} [url=currentUrl]
     * @return {router}     router object
     */
    getRouterFromUrl(url) {
      let routerObj
      url = url || location.href

      if (!this.routersToSearch) {
        this.initRoutersToSearch()
      }

      // map to faster search;
      if (!this.mappedUrls) {
        this.mappedUrls = {}
      } else if (this.mappedUrls[url]) {
        return this.mappedUrls[url]
      }

      _.forEach(this.routersToSearch, (route, name) => {
        routerObj = route && route.match(url)
        if (routerObj) {
          // map to fasterSearch;
          this.mappedUrls[url] = routerObj
          return false
        }
      })

      if (!routerObj && APP.page && APP.page.route) {
        /**
         * if router is not in fosJsRouting
         *    and there was no pushHistrony
         *    and if APP.page.route value form php
         */
        routerObj = {
          name: APP.page.route,
          params: {
            _locale: this.lang,
          },
        }
      }

      return routerObj
    },

    /**
     * Redirectiong page by url
     * @param  {string}  redirectUrl                url to redirect to
     * @param  {boolien} [withoutRedirect=false]    if redirect or push state (default true)
     * @param  {string}  [newTitle]                 new page title
     * @return void
     */
    redirect(redirectUrl, withoutRedirect, newTitle) {
      if (withoutRedirect) {
        if (window.history.pushState) {
          if (!newTitle) {
            newTitle = document.title
          }
          pushStateId++
          const pushStateObj = { page: pushStateId }
          window.history.pushState(pushStateObj, newTitle, redirectUrl)
          this.pageChanged({ state: pushStateObj })
        } else {
          window.location.href = `#${redirectUrl}`
        }
      } else {
        window.location.href = redirectUrl
      }
    },

    /**
     * Redirect page by router name
     * @param  {string}  name                       router name
     * @param  {object}  [params]                   router params
     * @param  {boolien} [withoutRedirect=false]    if redirect or push state (default true)
     * @param  {string}  [newTitle]                 new page title
     * @return void
     */
    pathRedirect(name, params, withoutRedirect, newTitle) {
      const url = this.path(name, params)

      if (url) {
        this.redirect(url, withoutRedirect, newTitle)
      }
    },

    /**
     * Getting clone of history
     * @return {array[router]}      array of router objects
     */
    getHistory() {
      return _.clone(localHistory)
    },

    /**
     * Getting single param from url
     * @param  {string} param param to get
     * @param  {string} [url=currentUrl]
     * @return {string}       value of url param
     */
    getUrlParam(param, url) {
      return (
        decodeURI((new RegExp(`${param}=` + '(.+?)(&|$)').exec(url || location.search) || [0, null])[1])
          // usuwanie błędu przekierowania po wylogowania i ponownym zalogowaniu
          .replace(/%3A/g, ':')
          .replace(/%2C/g, ',')
      )
    },

    /**
     * Getting all url params
     * @param  {string} [url=currentUrl]
     * @return {object}     object of all url params
     */
    getUrlParams(url) {
      let query
      if (url) {
        query = url.split('?')[1]
        if (!query) {
          return {}
        }
      } else {
        query = location.search.substr(1)
      }
      const result = {}
      query.split('&').forEach((part) => {
        if (!part) {
          return
        }
        const item = part.split('=')
        let key = item[0]
        const from = key.indexOf('[')

        // usuwanie błędu przekierowania po wylogowania i ponownym zalogowaniu
        item[1].replace(/%3A/g, ':').replace(/%2C/g, ',')

        if (from === -1) {
          result[key] = decodeURIComponent(item[1])
        } else {
          const to = key.indexOf(']')
          const index = key.substring(from + 1, to)
          key = key.substring(0, from)
          if (!result[key]) {
            result[key] = []
          }
          if (!index) {
            result[key].push(item[1])
          } else {
            result[key][index] = item[1]
          }
        }
      })

      return result
    },

    /**
     * Redirect to previous page
     * @param  {boolien} [withoutRedirect=false] if rideredct by history API
     * @param  {number}  [goToId=-1]             how meny steps go back
     * @return this
     */
    prevPage(withoutRedirect, goToId) {
      if (window.history.length > 1) {
        if (withoutRedirect) {
          window.history.go(goToId || -1)
        } else {
          window.history.back()
        }
        return true
      }

      return this
    },

    nextPage(withoutRedirect, goToId) {
      if (window.history.length > 1) {
        if (withoutRedirect) {
          window.history.go(goToId || +1)
        } else {
          window.history.forward()
        }
        return true
      }

      return this
    },

    /**
     * Refresh page
     * @return this
     */
    refresh() {
      location.reload()

      return this
    },
  })

  const router = new RouterModel()
  module.exports = router
}
